import { Component, OnInit } from "@angular/core";
import { DataService_Staff_DigitalID } from "../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "caass-staff-digital-id-email-log",
	templateUrl: "./staff-digital-id-email-log.component.html",
	styleUrls: ["./staff-digital-id-email-log.component.css"],
})
export class StaffDigitalIdEmailLogComponent implements OnInit {
	constructor(private idService: DataService_Staff_DigitalID) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadEmailLog();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedEmailLog: any;
	lstEmailLog: any = [];

	//Filter lists
	lstSuccessfulDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StaffID", header: "Staff ID" },
		{ field: "StaffName", header: "Name" },
		{ field: "Email", header: "Email" },
	];

	cols2: any = [
		//INSERT CUSTOM COLUMNS HERE
		// { field: 'RegistrationExpireDTDesc', header: 'Key Expires' },
		{ field: "c_dateDesc", header: "Sent Time" },
		{ field: "AdminPersonName", header: "Sent By" },
		{ field: "Response", header: "Response" },
		// { field: 'SuccessfulDesc', header: 'Successful' },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadEmailLog() {
		this.loading = true;

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.idService.EmailLogInfoSelectList(fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstEmailLog = response;

				//Load Data Filter Lists
				this.lstSuccessfulDesc = Array.from(new Set(this.lstEmailLog.map((item: any) => item.SuccessfulDesc)));

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadEmailLog();
	}

	//Custom Button Methods

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedEmailLog = val.data;
	}
	onRowUnselect(val) {
		this.SelectedEmailLog = null;
	}
	onRowDblClick(EmailLog) {
		this.SelectedEmailLog = EmailLog;
		// this.onEditGuardianNotifyEmailLog();
	}

	onStartDateChange(val) {
		this.StartDate = val;

		this.loadEmailLog();
	}

	onEndDateChange(val) {
		this.EndDate = val;

		this.loadEmailLog();
	}

	////////////////////////////////////////////
}
